module.exports = __webpack_public_path__ + "static/media/public_art.45f14e71.png";